var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Asignarme Expediente " + _vm.file.numero,
        centered: "",
        "hide-footer": ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", [
        _vm._v(
          " Al asignarte el expediente serás responsable y podrás realizar acciones sobre éste "
        )
      ]),
      _c("div", [
        _c("small", [
          _vm._v(" (Esta acción puede demorar unos segundos en completarse) ")
        ])
      ]),
      _c(
        "div",
        {
          staticClass: "m-top-20",
          staticStyle: { display: "flex", "justify-content": "flex-end" }
        },
        [
          _c(
            "vs-button",
            {
              attrs: { color: "dark", type: "border" },
              on: {
                click: function($event) {
                  return _vm.cancelAsign()
                }
              }
            },
            [_vm._v("Cancelar ")]
          ),
          _c(
            "vs-button",
            {
              staticStyle: { "margin-left": "12px" },
              attrs: { color: "primary", type: "border" },
              on: {
                click: function($event) {
                  return _vm.asignFile()
                }
              }
            },
            [_vm._v(" Si, asignar ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }